module.exports = __webpack_public_path__ + "static/zedindustriesgreen-logo-42996f544b337a4661a94f2b030a6e32.png";